import { PlusIcon, TrashIcon } from '@primer/octicons-react';
import { Box, useConfirm } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { clubApi } from '../../api/clubApi';
import Button from '../../components/ui/button/Button';
import DataTable from '../../components/ui/data-table';
import { IColumn } from '../../components/ui/data-table/DataTable';
import Text from '../../components/ui/text';
import { useCommonContext } from '../../contexts/common';
import { NotifyHelper } from '../../helpers/toast';
import { IClubResgistration } from '../../models/response/club/IClubResgistration';
import ClubRegistrationDetailModal from './ClubRegistrationDetailModal';

const ClubRegistrationPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState<IClubResgistration[]>([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedId, setSelectedId] = useState<number>(0);
    const { translate } = useCommonContext();
    const confirm = useConfirm();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        handleReloadAsync();
    }, [])
    const handleReloadAsync = async () => {
        setIsLoading(true);
        const res = await clubApi.clubSelect();
        setIsLoading(false)
        if (res.is_success) {
            setDataSource(res.data)
        } else {
            NotifyHelper.Error(res.message ?? "Có lỗi")
        }
    }
    const handleSendNotify = async (id: number) => {
        if (await confirm({
            content: "Gửi thông báo tới PHHS",
            title: "Xác nhận",
            cancelButtonContent: "Đóng",
            confirmButtonContent: "Gửi thông báo",
            confirmButtonType: "primary"
        })) {
            setIsSaving(true);
            const res = await clubApi.sendNotify(id);
            setIsSaving(false);
            if (res.is_success) {
                handleReloadAsync();
                NotifyHelper.Success("Success");
            } else {
                NotifyHelper.Error(res.message ?? "");
            }
        }
    }
    const onDelete = async (clbId: number) => {
        if (await confirm({
            content: "Bạn có chắc chắn muốn xóa nội dung này",
            title: "Xóa câu lạc bộ",
            cancelButtonContent: "Không xóa",
            confirmButtonContent: "Xóa",
            confirmButtonType: "danger"
        })) {
            const res = await clubApi.clubDelete(clbId);
            if (res.is_success) {
                handleReloadAsync();
                NotifyHelper.Success("Success");
            } else {
                NotifyHelper.Error(res.message ?? "Error")
            }
        }
    }
    const columns = useMemo((): any => {
        let result: IColumn[] = [
            {
                dataField: "sis_club_registration_period_name",
                minWidth: "180px",
                isMainColumn: true,
                caption: `${translate('Đợt đăng ký')}`
            },
            {
                dataField: "name",
                minWidth: "180px",
                isMainColumn: true,
                caption: `${translate('Base.Label.Name')}`,
                cellRender: (data: IClubResgistration) => {
                    return (
                        <Box
                            sx={{ cursor: "pointer", color: "blue" }}
                            onClick={() => {
                                setSelectedId(data.id);
                                setIsOpenModal(true);
                            }}
                        >
                            {data.name}
                        </Box>
                    );
                }
            },
            {
                dataField: "name_en",
                minWidth: "180px",
                isMainColumn: true,
                caption: `${translate('Base.Label.NameEn')}`,
                cellRender: (data: IClubResgistration) => {
                    return (
                        <Box
                            sx={{ cursor: "pointer", color: "blue" }}
                            onClick={() => {
                                setSelectedId(data.id);
                                setIsOpenModal(true);
                            }}
                        >
                            {data.name_en}
                        </Box>
                    );
                }
            },
            {
                dataField: "capacity",
                width: "120px",
                isMainColumn: true,
                caption: `${translate('Sĩ số')}`,
            },
            {
                id: "cmd",
                width: "100px",
                caption: `${translate('Base.Label.Command')}`,
                cellRender: (data: IClubResgistration) => {
                    return (
                        <>
                            <Button icon={TrashIcon} aria-label='' variant='danger' onClick={() => {
                                onDelete(data.id)
                            }} />
                        </>
                    );
                }
            },
        ];

        return result;
    }, []);

    return (
        <Box sx={{
            // p: 3
        }}>
            <Box>
                <DataTable
                    titleComponent={
                        <>
                            <Text text={`${translate("Danh sách")}`} sx={{
                                fontSize: "24px"
                            }} />
                        </>
                    }
                    subTitle={`${translate("Base.Label.TotalCount")}: ${(dataSource?.length ?? 0).toLocaleString()}`}
                    searchEnable
                    isLoading={isLoading}
                    actionComponent={
                        <Box sx={{ display: "flex" }}>
                            <Button
                                text='Thêm mới'
                                leadingVisual={PlusIcon}
                                variant='primary'
                                onClick={() => {
                                    setSelectedId(0);
                                    setIsOpenModal(true);
                                }}
                            />
                        </Box>
                    }
                    columns={columns}
                    data={dataSource}
                    height={`${window.innerHeight - 250}px`}
                />
            </Box>
            {isOpenModal &&
                <ClubRegistrationDetailModal
                    isOpen={isOpenModal}
                    id={selectedId}
                    onClose={() => setIsOpenModal(false)}
                    onSuccess={() => {
                        handleReloadAsync();
                    }}
                />
            }
        </Box>
    );
};

export default ClubRegistrationPage;